define('InputView',['backbone', 'underscore', 'jquery'], function (Backbone, _, $) {

    var InputView = Backbone.View.extend({
        events: {
            'blur': 'update'
        },
        initialize: function(){

            var self = this, el = self.el;
            self.update();
            el.isInputView = true;

            // Check manuel pour détecter le moment ou l'autocomplete navigateur a été fait, les 5 premières secondes
            var counter = 0;
            var interval = setInterval(function(){
                counter ++;
                if(counter > 20){
                    clearInterval(interval);
                }else{
                    self.update();
                }
            }, 250);

            if(el.type === 'date'){
                el.type = 'input';
                // si value a un format invalide (YYYY/MM/DD) mais présent, on l’utilise
                el.value = self.$el.attr('value') || '';
                self.$el.addClass('input-date');
                self.delegateEvents(_.defaults({keyup:'onDateKeyup'},self.events));
            }
        },
        onDateKeyup:function(e){
            // date autoformat
            var input = $(e.currentTarget),
                val = input.val(),
                length = val.length;
            if (e.keyCode !== 8) {
                if ((length === 2) || (length === 5)) {
                    input.val(val + "/");
                }
            }
            if (length > 10) {
                input.val(val.slice(0, -1));
            }
        },
        remove:function(){
            Backbone.View.prototype.remove.apply(this);
        },
        update: function(){
            var ua = navigator.userAgent.toLowerCase(); // User Agent
            if(ua.indexOf('chrome') > -1 || ua.indexOf('safari') > -1 || ua.indexOf('mozilla') > -1) {
                var closestInput = this.$el.closest('.input'),
                    val = this.$el.val();
                closestInput.toggleClass('input-filled',val != '');
            }

        }
    });

    InputView.initializeInputsOfView = function(view){
        var views = [];
        view.$('.input input').each(function(){
            if(!this.isInputView) views.push(new InputView({el:this}));
        });
        return views;
    };

    return InputView;

});

